import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  created: null,
  updated: null,
  disabledRestored: null,
};

const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    setCreatedBranch: (state, action) => {
      state.created = action.payload;
    },
    setUpdatedBranch: (state, action) => {
      state.updated = action.payload;
    },
    setDisabledRestoredBranch: (state, action) => {
      state.disabledRestored = action.payload;
    },
  },
});

export const { setCreatedBranch, setUpdatedBranch, setDisabledRestoredBranch } = branchSlice.actions;
export default branchSlice.reducer;